import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import RecordsList from './pages/RecordsList';
import RecordShow from './pages/RecordShow';
import RecordEdit from './pages/RecordEdit';
import RecordNew from './pages/RecordNew';
import ImportPage from './pages/ImportPage';
import DuplicatesList from './pages/DuplicatesList';
import MergePage from './pages/MergePage';
import PendingSales from './pages/PendingSales';
import 'leaflet/dist/leaflet.css';
import './styles.css';
import './records.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/listings" element={<RecordsList />} />
      <Route path="/import" element={<ImportPage />} />
      <Route path="/pending" element={<PendingSales />} />
      <Route path="/duplicates" element={<DuplicatesList />} />
      <Route path="/duplicates/:eircode/merge" element={<MergePage />} />
      <Route path="/listings/new" element={<RecordNew />} />
      <Route path="/listings/:id" element={<RecordShow />} />
      <Route path="/listings/:id/edit" element={<RecordEdit />} />
    </Routes>
  </BrowserRouter>
);
